import styled from "styled-components";

export const ActionTimelineStyled = styled.div`
  .timeline_title {
    margin-bottom: 0.75rem;
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
  }
  .timeline_wrap {
    display: flex;
    flex-direction: column;
    .timeline_item {
      position: relative;
      padding-left: 1.75rem;
      padding-bottom: 1.25rem;
      &:before {
        content: "";
        position: absolute;
        left: 5px;
        top: 4px;
        bottom: 0;
        width: 2px;
        background: #e0e0e0;
      }
      &:last-child {
        padding-bottom: 0;
        &:before {
          display: none;
        }
      }
      .timeline_dot {
        position: absolute;
        left: 0;
        top: 2px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #c4c4c4;
        z-index: 1;
      }
      .timeline_body {
        .timeline_action {
          font-weight: 600;
        }
        .timeline_meta {
          font-size: 0.8rem;
          color: #888;
          margin-top: 0.1rem;
        }
        .timeline_note {
          font-size: 0.85rem;
          color: #555;
          margin-top: 0.2rem;
          word-break: break-word;
        }
      }
    }
    .timeline_empty {
      color: #888;
      font-size: 0.9rem;
    }
  }
`;
